import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

const MasterLayoutTemplate = ({ render, children, ...props }) => {
	return (
		<React.Fragment>
			{children}
			{render(props)}
		</React.Fragment>
	);
};

MasterLayoutTemplate.propTypes = {
	render: PropTypes.func,
};

export default observer(MasterLayoutTemplate);
